<script>
    export default {
        inject: ['EventBus', 'PIXIWrapper'],
        // x, y define the sprite's position in the parent.
        // imagePath is the path to the image on the server to render as the sprite.
        props: {
            x: {
                type: Number,
                default: 0,
                required: true,
            },
            y: {
                type: Number,
                default: 0,
                required: true,
            },
            anchor: {
                type: Number,
                default: 0,
            },
            value: {
                type: String,
                default: '',
                required: true,
            },
            fontSize: {
                type: Number,
                default: 12,
            },
            fill: {
                type: String,
                default: '#FFFFFF',
            },
        },

        data() {
            return {
                sprite: null
            }
        },

        render(h) { return h() },

        created() {
            let style = new this.PIXIWrapper.PIXI.TextStyle({
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: this.fontSize,
                align: 'center',
                fill: this.fill,
                /*
                dropShadow: true,
                dropShadowColor: '#FFFFFF',
                dropShadowBlur: 5,
                dropShadowDistance: 0,
                stroke: '#FFFFFF',
                strokeThickness: 5,
                */
                breakWords: true,
            });

            this.sprite = new this.PIXIWrapper.PIXI.Text(this.value, style);
            // Set the initial position.
            this.sprite.x = this.x;
            this.sprite.y = this.y;
            this.sprite.anchor.set(this.anchor);

            // Opt-in to interactivity.
            this.sprite.interactive = true;

            // When the PIXI renderer starts.
            this.EventBus.$on('ready', () => {
                // Add the sprite to the parent container or the root app stage.
                if (this.$parent.container) {
                    this.$parent.container.addChild(this.sprite);
                } else {
                    this.PIXIWrapper.PIXIApp.stage.addChild(this.sprite);
                }

                let scale = this.$parent.$parent.$refs.renderCanvas.offsetWidth / 640;
                this.sprite.x *= scale;
                this.sprite.y *= scale;
                this.sprite.scale.x = this.sprite.scale.y =scale;
            });
        }
    }
</script>
